<template>
  <v-dialog
    v-if="template"
    v-model="isVisible"
    :fullscreen="isFullScreen"
    max-width="300"
    persistent
    scrollable
  >
    <v-card>
      <v-toolbar
        class="pl-1"
        flat
        height="80"
        max-height="80"
      >
        <v-avatar
          class="mr-3"
          color="blue"
        >
          <v-icon color="blue lighten-5">
            {{ $t('Marketing.Print.Dialog.PreviewTemplate.Toolbar.Icon') }}
          </v-icon>
        </v-avatar>


        <v-toolbar-title
          class="pl-1"
        >
          <div class="body-3">
            {{ $t('Marketing.Print.Dialog.PreviewTemplate.Toolbar.Title') }}
          </div>
          <div class="text-caption">
            {{ $t('Marketing.Print.Dialog.PreviewTemplate.Toolbar.SubTitle') }}
          </div>
        </v-toolbar-title>

        <v-spacer />

        <v-toolbar-title
          class="px-4"
        >
          <div class="text-caption">
            {{ template.DateAdded }} {{ template.TimeAdded }}
          </div>
        </v-toolbar-title>

        <v-btn
          class="ml-0"
          icon
          @click="onCancelButtonClick"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider />

      <div
        class="text-center"
        style="width: 100%; height: 100%;"
      >
        <iframe
          ref="templateFrame"
          style="border: 0; width: 300px; height: 100%; background-color: #FFFFFF"
        />
      </div>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn
          class="light-blue--text text--darken-1"
          outlined
          @click="onCancelButtonClick"
        >
          {{ $t('Common.Button.Close').toLocaleUpperCase($i18n.locale) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Auth from '@/mixins/auth'
import DialogVisible from '@/mixins/dialogVisible'

export default {
  name      : 'PrintTemplatePreviewDialog',
  components: {},
  mixins    : [Auth, DialogVisible],
  props     : {
    template: {
      type   : Object,
      default: undefined
    }
  },
  data() {
    return {
      isFullScreen: true
    }
  },
  computed: {
    htmlContent() {
      return this.template.Body || ''
    }
  },
  watch: {
    isVisible(val) {
      if (val) {
        this.setTemplateFrameContent(this.htmlContent)
      } else {
        this.setTemplateFrameContent('')
      }
    }
  },
  created() {
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  methods: {
    setTemplateFrameContent(htmlContent) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          const iframeElement = this.$refs.templateFrame
          if (!iframeElement) return

          iframeElement.src = 'about:blank'
          iframeElement.contentWindow.document.open()
          iframeElement.contentWindow.document.write(htmlContent)
          iframeElement.contentWindow.document.close()
        })
      })
    },

    onCancelButtonClick() {
      this.closeDialog()
    }
  }
}
</script>
